/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import TenantActions from '@Actions/tenantActions';
import './style.scss';
import {
  Select, Table, Popconfirm, Checkbox,
} from 'antd';
import {
  DeleteOutlined, PlusCircleFilled,
} from '@ant-design/icons';
import { CountryCodes } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import MemberActions from '@Actions/memberActions';
import { v4 as uuidv4 } from 'uuid';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const MemberForm = ({
  user, selectedMember, createMember, createMemberLoading, callback, updateMember, getTenants, tenantsRoles, updateMemberLoading, getMaskingPolicies, maskingPolicies, tenants, getTenantsLoading, getTenantsRolesLoading, getTenantsRoles,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [name, setName] = useState('');
  const [email, _setEmail] = useState('');
  const [diffUsername, setDiffUsername] = useState(false);
  const [username, setUsername] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [phone, setPhone] = useState('');
  const [maskingPolicy, setMaskingPolicy] = useState('');
  const [data, setData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserActive, setIsUserActive] = useState(true);
  const [isLoginWithPhone, setIsLoginWithPhone] = useState(true);
  const [isLoginWithEmail, setIsLoginWithEmail] = useState(true);
  const [sessionTime, setSessionTime] = useState('15d');

  function setEmail(input) {
    _setEmail(input);
    if(diffUsername===false){
      setUsername(input);
    }
  }

  useEffect(() => {
    getMaskingPolicies(user?.tenant_info?.org_id);
    getTenants(1, '', true, user?.tenant_info?.org_id);
    getTenantsRoles();
    if (selectedMember) {
      setMaskingPolicy(selectedMember?.data_masking_policy_id);
      _setEmail(selectedMember?.email);
      setUsername(selectedMember?.username);
      if (selectedMember?.email?.trim() !== selectedMember?.username?.trim()) setDiffUsername(true);
      setName(`${selectedMember?.first_name ? selectedMember?.first_name : ''} ${selectedMember?.last_name ? selectedMember?.last_name : ''}`);
      setCountryCode(String(selectedMember?.dial_code) || Helpers.getDialCode(user?.tenant_info?.country_code));
      setPhone(selectedMember?.mobile);
      setData(selectedMember?.tenant_user?.filter((tenantUser) => tenantUser?.tenant_role_id)?.map((item) => ({ ...item, key: uuidv4() })));
      setSessionTime(selectedMember?.custom_session_duration || '15d');
      setIsUserActive(selectedMember?.is_active);
      setIsLoginWithPhone(selectedMember?.login_with_phone);
      setIsLoginWithEmail(selectedMember?.login_with_email);
    } else {
      setCountryCode(Helpers.getDialCode(user?.tenant_info?.country_code));
      setData([{
        key: uuidv4(), tenant_id: null, tenant_role_id: null, tenant_roles: [], is_active: true,
      }]);
    }
  }, []);

  const isDataValid = () => {
    let isValid = true;
    for (let i = 0; i < data?.length; i++) {
      if (!data?.[i]?.tenant_id || !data?.[i]?.tenant_role_id) {
        isValid = false;
      }
    }
    return isValid;
  };

  const addMember = () => {
    setFormSubmitted(true);

    if (isDataValid() && Helpers.validateEmail(email) && Helpers.validatePhoneNumber(phone) && name) {
      const tenantUser = data?.map((item) => ({
        tenant_id: item.tenant_id,
        is_active: item.is_active,
        tenant_role_id: item.tenant_role_id,
      }));
      let _username = username;
      if (!_username) _username = email;
      const payload = {
        user_id: selectedMember ? selectedMember?.user_id : null,
        username: _username,
        email,
        first_name: name,
        dial_code: countryCode,
        mobile: phone?.toString(),
        is_active: selectedMember ? isUserActive : true,
        data_masking_policy_id: maskingPolicy || null,
        tenant_user: tenantUser,
        login_with_phone: isLoginWithPhone,
        login_with_email: isLoginWithEmail,
        custom_session_duration: sessionTime,
      };

      if (selectedMember) {
        updateMember(payload, () => callback());
      } else {
        createMember(payload, () => callback());
      }
    }
  };

  const updateTableValue = (key, value, label) => {
    const copyData = data.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setData(copyData);
  };

  const addNewRow = () => {
    if (data?.length) {
      setData([...data, { key: uuidv4(), is_active: true }]);
    } else {
      setData([{}]);
    }
  };

  const removeRow = (key) => {
    if (data?.length === 1) {
      setData([
        {
          key: uuidv4(),
          tenant_id: '',
        },
      ]);
    } else {
      const copyData = data.filter((item) => item.key !== key);
      setData(copyData);
    }
  };

  const getSelectedTenant = (record) => data?.filter((item) => !item?.is_deleted).filter((item) => item?.tenant_id !== record?.tenant_id).map((tenant) => tenant.tenant_id);

  const columns = [
    {
      title: 'Business Unit Name',
      width: '250px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record?.tenant_id}
            showSearch
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'tenant_id');
              updateTableValue(record?.key, '', 'tenant_role_id');
              setSearchKeyword('');
              const copyData = JSON.parse(JSON.stringify(data));
              for (let i = 0; i < copyData?.length; i++) {
                if (copyData[i]?.key === record?.key) {
                  copyData[i].tenant_roles = tenantsRoles?.data?.find((tenantsRole) => tenantsRole?.tenant_id === value)?.tenant_roles;
                }
              }
              setData(copyData);
            }}
            placeholder="Select Business Unit"
            style={{
              border: !(formSubmitted && !record?.tenant_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              borderRadius: '2px',
              height: '28px',
              width: '225px',
              fontSize: '13px',
              marginRight: '10px',
            }}
            onSearch={(value) => {
              setSearchKeyword(value);
            }}
            disabled={getTenantsLoading}
          >
            {tenants?.data
              ?.filter((item) => !getSelectedTenant(record)?.includes(item?.tenant_id))
              ?.filter((item) => (searchKeyword ? item?.tenant_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))
              .map(
                (item) => <Option key={item?.tenant_id} value={item?.tenant_id}>{item?.tenant_name}</Option>,
              )}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: 'Role',
      width: '250px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record?.tenant_role_id}
            showSearch
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'tenant_role_id');
              setSearchKeyword('');
            }}
            placeholder="Select Role"
            style={{
              border: !(formSubmitted && !record?.tenant_role_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              borderRadius: '2px',
              height: '28px',
              width: '225px',
              fontSize: '13px',
              marginRight: '10px',
            }}
            onSearch={(value) => {
              setSearchKeyword(value);
            }}
            disabled={getTenantsRolesLoading}
          >
            {record?.tenant_roles?.filter((item) => (searchKeyword ? item?.tenant_role_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))
              .map(
                (item) => <Option key={item?.tenant_role_id} value={item?.tenant_role_id}>{item?.tenant_role_name}</Option>,
              )}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: 'Active',
      width: '60px',
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Checkbox
            checked={record?.is_active}
            onChange={(e) => {
              updateTableValue(record?.key, e.target.checked, 'is_active');
            }}
          />
        </div>
      ),
    },
    {
      title: '',
      render: (record) => (
        <div>
          <div style={{ display: 'flex', alignItems: 'baseline', }}>
            <Popconfirm
              placement="topRight"
              title="Are you sure you want to delete this line?"
              onConfirm={() => removeRow(record?.key)}
              okText="Yes"
              cancelText="No"
            >
              <div className="deleteButton">
                {' '}
                <DeleteOutlined />
                {' '}
              </div>
            </Popconfirm>
          </div>
        </div>
      ),
    },
  ];

  const sessionData = [
    {
      name: '30 Minutes',
      value: '30m',
    },
    {
      name: '1 Hour',
      value: '1h',
    },
    {
      name: '4 Hour',
      value: '4h',
    },
    {
      name: '8 Hour',
      value: '8h',
    },
    {
      name: '12 Hour',
      value: '12h',
    },
    {
      name: '1 Day',
      value: '1d',
    },
    {
      name: '3 Day',
      value: '3d',
    },
    {
      name: '7 Day',
      value: '7d',
    },
    {
      name: '15 Day',
      value: '15d',
    },
    {
      name: '30 Day',
      value: '30d',
    },
  ];

  const getDataSource = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    return copyData;
  };

  return (
    <div className="member-form__wrapper">
      <div className="member-form__header-wrapper">
        <div className="ant-row">
          <div className="ant-col-md-12 ant-col-xs-24">
            <H3FormInput
              name="Name"
              type="text"
              containerClassName="orgInputContainer member-form__left-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setName(event.target.value)}
              value={name}
              label="Name"
              required
              showError={formSubmitted && !(name)}
              maxlength="50"
              disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
            />
          </div>
          <div className="ant-col-md-12 ant-col-xs-24">
            <H3FormInput
              name="a valid email"
              type="text"
              containerClassName="orgInputContainer member-form__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setEmail(event.target.value)}
              value={email}
              required
              showError={formSubmitted && !Helpers.validateEmail(email)}
              label="Email"
              disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
            />
          </div>
          <div className="ant-col-md-12 ant-col-xs-24">
            <H3FormInput
              name="Should be a valid email"
              type="text"
              containerClassName="orgInputContainer member-form__left-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setUsername(event.target.value)}
              value={username}
              required
              showError={formSubmitted && !Helpers.validateEmail(username)}
              label="Username"
              disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading || !diffUsername}
            />
          </div>
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="member-form__right-input" style={{ marginBottom: '12px' }}>
              <H3Text
                required
                text="Phone"
                className="orgFormLabel"
              />
              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <PRZSelect
                  value={countryCode}
                  showSearch
                  filterOption={(input, option) => {
                    const { label } = option.props;
                    const { value } = option.props;
                    return (
                      label.toLowerCase().includes(input.toLowerCase())
                            || value.toLowerCase().includes(input.toLowerCase())
                    );
                  }}
                  onChange={(value) => setCountryCode(value)}
                  style={{
                    border: !(formSubmitted && !countryCode)
                      ? '1px solid rgba(68, 130, 218, 0.2)'
                      : '1px solid red',
                    borderRight: 'none',
                    borderRadius: '2px',
                    height: '28px',
                    width: '100px',
                    fontSize: '13px',
                  }}
                  disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
                >
                  {CountryCodes?.map((item) => (
                    <Option
                      key={item?.name}
                      value={item?.dial_code}
                      label={item?.name}
                    >
                      {`${item?.flag} +${item?.dial_code}`}
                    </Option>
                  ))}
                </PRZSelect>
                <H3FormInput
                  name="a valid phone number"
                  type="text"
                  containerClassName="member-form__inner-input"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  onChange={(event) => setPhone(event.target.value)}
                  value={phone}
                  disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
                  maxlength="50"
                  showError={formSubmitted && phone && !Helpers.validatePhoneNumber(phone)}
                />
              </div>
            </div>
          </div>
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="member-form__left-input">
              <H3Text
                text="Session Time"
                className="orgFormLabel"
              />
              <div>
                <PRZSelect
                  value={sessionTime}
                  showSearch
                  onChange={(value) => setSessionTime(value)}
                  style={{
                    borderRadius: '2px',
                    height: '28px',
                    width: '100%',
                    fontSize: '13px',
                    marginBottom: '12px',
                  }}
                  disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
                >
                  {sessionData?.map((sd) => (
                    <Option
                      key={sd?.name}
                      value={sd?.value}
                    >
                      {`${sd?.name}`}
                    </Option>
                  ))}
                </PRZSelect>
              </div>
            </div>
          </div>
          {user?.tenant_info?.global_config?.sub_modules?.data_masking?.is_active ? (
            <div className="ant-col-md-12 ant-col-xs-24">
              <div className="member-form__right-input">
                <H3Text
                  text="Data Masking Policy"
                  className="orgFormLabel"
                />
                <div>
                  <PRZSelect
                    value={maskingPolicy}
                    showSearch
                    onChange={(value) => setMaskingPolicy(value)}
                    disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
                    allowClear
                    onClear={() => setMaskingPolicy(null)}
                  >
                    {maskingPolicies?.data?.map((mp) => (
                      <Option
                        key={mp?.data_masking_policy_id}
                        value={mp?.data_masking_policy_id}
                      >
                        {`${mp?.data_masking_policy_name}`}
                      </Option>
                    ))}
                  </PRZSelect>
                </div>
              </div>
            </div>
          ) : <div className="ant-col-md-12 ant-col-xs-24" />}
          <div className="ant-col-md-24 ant-col-xs-24">
            <Checkbox
              checked={isUserActive}
              onChange={() => {
                setIsUserActive(!isUserActive);
              }}
            >
              Activate User
            </Checkbox>
          </div>
          <div className="ant-col-md-24 ant-col-xs-24">
            <Checkbox
              checked={isLoginWithPhone}
              onChange={() => {
                setIsLoginWithPhone(!isLoginWithPhone);
              }}
            >
              Login with Phone
            </Checkbox>
          </div>
          <div className="ant-col-md-24 ant-col-xs-24">
            <Checkbox
              checked={isLoginWithEmail}
              onChange={() => {
                setIsLoginWithEmail(!isLoginWithEmail);
              }}
            >
              Login with Email
            </Checkbox>
          </div>
          <div className="ant-col-md-24 ant-col-xs-24">
            <Checkbox
              checked={diffUsername}
              onChange={(e) => {
                if (e.target.checked === false) setUsername(email);
                setDiffUsername(e.target.checked);
              }}
            >
              Choose different username for user
            </Checkbox>
          </div>
        </div>
      </div>
      <div className="member-form__body-wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24">
            <Table
              bordered
              showHeader
              size="small"
              loading={getTenantsLoading}
              columns={columns}
              dataSource={getDataSource()}
              currentPage
              pagination={false}
            />
          </div>
        </div>
        <div
          className="new-row-button"
          style={{ marginLeft: '10px', marginBottom: '10px' }}
          onClick={() => {
            addNewRow();
          }}
        >
          <span className="new-row-button__icon"><PlusCircleFilled /></span>
          <div>New Item</div>
        </div>
      </div>
      <div className="member-form__footer-wrapper">
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text={selectedMember ? `Update User` : 'Add User'}
              onClick={() => addMember()}
              isLoading={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
              disabled={createMemberLoading || updateMemberLoading || getTenantsRolesLoading}
              style={{
                width: '200px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, MaskingPolicyReducers, MemberReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  getTenantsRolesLoading: MemberReducers.getTenantsRolesLoading,
  createMemberLoading: MemberReducers.createMemberLoading,
  updateMemberLoading: MemberReducers.updateMemberLoading,
  maskingPolicies: MaskingPolicyReducers.maskingPolicies,
  tenantsRoles: MemberReducers.tenantsRoles,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTenantsRoles: (callback) => dispatch(
    MemberActions.getTenantsRoles(callback),
  ),
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  createMember: (payload, callback) => dispatch(MemberActions.createMember(payload, callback)),
  updateMember: (payload, callback) => dispatch(MemberActions.updateMember(payload, callback)),
  getMaskingPolicies: (orgId, maskingPolicyId, page, limit, callback) => dispatch(MaskingPolicyActions.getMaskingPolicies(orgId, maskingPolicyId, page, limit, callback)),
});

MemberForm.propTypes = {
  user: PropTypes.any,
  createMemberLoading: PropTypes.bool,
  getTenantsRolesLoading: PropTypes.bool,
  callback: PropTypes.any,
  createMember: PropTypes.func,
  getTenantsRoles: PropTypes.func,
  getTenants: PropTypes.func,
  getTenantsLoading: PropTypes.bool,
  selectedMember: PropTypes.any,
  updateMember: PropTypes.func,
  updateMemberLoading: PropTypes.bool,
  tenantsRoles: PropTypes.any,
  tenants: PropTypes.any,
  maskingPolicies: PropTypes.any,
  getMaskingPolicies: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MemberForm));
